// internal-deps
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { IColors } from "@swiggy-private/dls-web-common/dist/components/types.internal";

// helpers
import { getStatusBannerMaxHeight } from "@dineout-payment-success-ui/helpers/index";

// styles
import styled from "styled-components";

// constants
import { STATUS_BANNER } from "@dineout-payment-success-ui/constants";

interface IColorKey {
    colorKey: keyof IColors;
    textColor?: string;
}

export const StatusBannerWrapper = styled.div<{
    showStatusDescription: boolean;
}>(({ showStatusDescription }) => ({
    textAlign: "center",
    position: "relative",
    maxHeight: getStatusBannerMaxHeight(showStatusDescription, false, false, false),
    overflow: "hidden",
}));

export const StatusText = styled(Text)<IColorKey>(({ textColor, colorKey, theme }) => ({
    color: textColor || theme.colors[theme.colorMode][colorKey],
    paddingBottom: theme.spacing.xxSmall,
}));

export const TextContentWrapper = styled.div({
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    top: STATUS_BANNER.TEXT_WRAPPER_TOP,
    width: "100%",
});

export const StyledImage = styled(Image)({
    height: "100%",
    objectFit: "cover",
    width: "100%",
});

export const RedemptionInstructionSubtext = styled(Text)<IColorKey>(({ textColor, colorKey, theme }) => ({
    width: "70%",
    color: textColor || theme.colors[theme.colorMode][colorKey],
}));

export const SubtextWrapper = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.xSmall,
    alignItems: "center",
}));
